import { api } from '../api/client.js';

export async function getMaklerDetail(maklerId) {
  const res = await api.get(`/maklerOverview/makler/${maklerId}`);
  return res.data.data;
}

export async function adjustMaklerPlan(planId, payload) {
  const res = await api.patch(`/weekClose/makler/${planId}/adjust`, payload);
  return res.data.data;
}

export async function closeMaklerWeek(planId) {
  const res = await api.patch(`/weekClose/makler/${planId}`);
  return res.data.data;
}

export async function closeAndStartNextWeek(planId, payload) {
  const res = await api.post(`/weekClose/makler/${planId}/next-week`, payload);
  return res.data.data;
}

export async function setMaklerPlan(maklerId, payload) {
  const res = await api.post(`/maklerOverview/makler/${maklerId}/plan`, payload);
  return res.data.data;
}

export async function addMaklerAbsence(maklerId, from, to) {
  const res = await api.put(`/maklerOverview/makler/${maklerId}/absences`, { from, to });
  return res.data.data;
}

export async function removeMaklerAbsence(maklerId, date) {
  await api.delete(`/maklerOverview/makler/${maklerId}/absences/${date}`);
}

export async function setMaklerSupport(maklerId, payload) {
  const res = await api.patch(`/maklerOverview/makler/${maklerId}/support`, payload);
  return res.data.data;
}

export async function getLevelCriteria(maklerId) {
  const res = await api.get(`/maklerOverview/makler/${maklerId}/level-criteria`);
  return res.data.data;
}
